//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { GOAL_ID_TO_GOAL_KEY } from '@/constants/goalIdByType'

export default {
  props: {
    /**
     * Goal name
     */
    goalName: {
      type: String,
      default: null
    },
    goalId: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapGetters({
      getPlanPrice: 'product/getPlanPrice'
    }),
    imageSource () {
      const imageKey = GOAL_ID_TO_GOAL_KEY[this.goalId]

      if (imageKey) {
        return imageKey
      } else {
        return 'weight-management' // Default value
      }
    },
    improvementProgramData () {
      let keyGoal = GOAL_ID_TO_GOAL_KEY[this.goalId]

      if (!keyGoal) {
        keyGoal = 'weight-management' // Default value
      }

      return this.$t(`quizResults.howWeHelp.improvementProgram.${keyGoal}`)
    }
  },
  methods: {
    emitTrackAddToCart () {
      this.$emit('trackAddToCart')
    }
  }
}
